import { pick } from 'lodash-es';
import { DateTime } from 'luxon';

import type { PricingSchemeRead } from 'src/common/external/bambi-api/bambiApi';

import type { SchemeMetaFormValues } from './metaDefaultValues';
import { defaultValues } from './metaDefaultValues';

const FRONTEND_ONLY_KEYS = [
  'mileage_range_lower_miles',
  'mileage_range_upper_miles',
];

export const getMetaDefaultValues = (
  originalPricingSchemeValues?: PricingSchemeRead
): SchemeMetaFormValues => {
  const now = DateTime.now();
  const startDate = now.minus({ months: 3 }).toISODate();
  const endDate = now.plus({ years: 10 }).toISODate();

  if (originalPricingSchemeValues) {
    const pickKeys = Object.keys(defaultValues).filter(
      (key) => key !== 'payer_ids' && !FRONTEND_ONLY_KEYS.includes(key)
    );
    const picked = pick(originalPricingSchemeValues, pickKeys);
    const lower = originalPricingSchemeValues.mileage_range_hundredths_lower;
    const upper = originalPricingSchemeValues.mileage_range_hundredths_upper;
    return {
      ...picked,
      mileage_range_lower_miles: lower != null ? lower / 100 : null,
      mileage_range_upper_miles: upper != null ? upper / 100 : null,
    } as SchemeMetaFormValues;
  }

  return {
    ...defaultValues,
    start_date: startDate,
    end_date: endDate,
  };
};
